module.exports = __webpack_public_path__ + "img/dashboard-default.95ec39a6.svg";